<mat-progress-bar
  [mode]="modeProgressBar"
  [value]="myValue"
  *ngIf="showProgressBar"
></mat-progress-bar>
